module.exports = __webpack_public_path__ + "static/media/sutaFavorableBG.e5a1302f.png";